import React from "react";

import styles from "./Requisites.module.scss";

const Requisites = () => {
  return (
    <div className="main-container main-container_large-top-indent">
      <div className="holder wrap no-pdn-top">
        <div className={styles.Requisites}>
          <h1 className="h1-title title-with-mrg">Реквизиты</h1>

          <h3 className="h3-title">
            Общество с ограниченной ответственностью «Проектмаркетинг+1»
          </h3>
          <p className="paragraph-small">(ООО «Проектмаркетинг +1»)</p>
          <br />
          <p className="paragraph-small">
            Директор Осадчий Александр Михайлович, действующий на основании
            Устава.
          </p>
          <br />
          <p className="paragraph-small">ОГРН 1142468002214</p>
          <p className="paragraph-small">ИНН 2465305834</p>
          <p className="paragraph-small">КПП 246501001</p>
          <br />
          <p className="paragraph-small">ОКПО 21948619</p>
          <p className="paragraph-small">ОКАТО 04401374000</p>
          <p className="paragraph-small">ОКТМО 04701000001</p>
          <br />
          <p className="paragraph-small">Юридический адрес:</p>
          <p className="paragraph-small">
            660119, г. Красноярск, пр. 60 лет образования СССР, 14-24
          </p>
          <br />
          <p className="paragraph-small">
            Фактический адрес (адрес для корреспонденции):{" "}
          </p>
          <p className="paragraph-small">
            660001, г. Красноярск, ул. Ладо Кецховели 22а, офис 13-07;
          </p>
          <br />
          <p className="paragraph-small">
            Телефон:{" "}
            <a href="tel:8 (800) 201-68-11" target="_self">
              8 (800) 201-68-11
            </a>
          </p>
          <p className="paragraph-small">
            Электронная почта:{" "}
            <a href="mailto:privet@proektmarketing.ru" target="_self">
              privet@proektmarketing.ru
            </a>
          </p>
          <p className="paragraph-small">
            Официальный сайт:{" "}
            <a href="https://proektmarketing.ru/">proektmarketing.ru</a>
          </p>
          <br />
          <h3 className="h3-title">Банковские реквизиты:</h3>
          <p className="paragraph-small">БИК 044525411</p>
          <p className="paragraph-small">р/с 40702810320460001121</p>
          <p className="paragraph-small">
            филиале «Центральный» Банка ВТБ (ПАО) в г. Москва
          </p>
          <p className="paragraph-small">к/с 30101810145250000411</p>
        </div>
      </div>
    </div>
  );
};

export default Requisites;
